// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File manager */
.file-manager-container {
	width: 100%;
	height: 100%;
	background: #fff;
	height: 650px;
	display: flex;
	flex-direction: column;
}

/* File manager body */
.file-manager__body {
	height: 100%;
	width: 100%;

	border: 1px solid #dee2e6;
	border-top: 0;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;

	display: flex;
	flex-direction: row;
	box-sizing: border-box;
}

/* Files */
.file-manager__body-files {
	width: 100%;
}

.file-manager__body-files__toolbar {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;

	width: 100%;
	border-bottom: 1px solid #dee2e6;
	height: 34px;
}

.file-manager__body-files__toolbar .search {
	padding: 0 16px;
}

.file-manager__body-files__toolbar .input-group-addon {
	background-color: transparent;
	padding-right: 0;
}

.file-manager__body .form-control:focus {
	box-shadow: none;
	border-color: #ccc;
}

/* Outras */
.file-manager__body-files__table {
	height: 575px;
	overflow-y: auto;
}

.file-manager__body-files__table .table {
	width: 100%;
}

.file-manager__body-files__table .table th {
	height: 32px;
}

.file-manager__body-files__table .table td {
	height: 34px;
}

.file-browser {
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	gap: 8px;
	padding: 8px;
}

.file-browser.list-view {
	padding: 0px;
}

.file-browser.list-view li a.disabled {
	color: #aaa;
	padding: 6px 20px;
}

.popup-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
}

.popup-content {
	background: white;
	padding: 20px;
	border-radius: 5px;
	position: relative;
}

.close-button {
	position: absolute;
	top: 10px;
	right: 10px;
	background: red;
	color: white;
	border: none;
	border-radius: 5px;
	padding: 5px 10px;
	cursor: pointer;
}

.file-image {
	max-width: 100%;
	max-height: 80vh;
}

.selection-rect {
	pointer-events: none;
	z-index: 1000;
}`, "",{"version":3,"sources":["webpack://./app/src/js/components/filemanager/file-browser.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,aAAa;CACb,aAAa;CACb,sBAAsB;AACvB;;AAEA,sBAAsB;AACtB;CACC,YAAY;CACZ,WAAW;;CAEX,yBAAyB;CACzB,aAAa;CACb,8BAA8B;CAC9B,+BAA+B;;CAE/B,aAAa;CACb,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA,UAAU;AACV;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,eAAe;CACf,8BAA8B;CAC9B,mBAAmB;;CAEnB,WAAW;CACX,gCAAgC;CAChC,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,6BAA6B;CAC7B,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA,WAAW;AACX;CACC,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;CACb,eAAe;CACf,mBAAmB;CACnB,QAAQ;CACR,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,8BAA8B;CAC9B,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,eAAe;CACf,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,aAAa;AACd","sourcesContent":["/* File manager */\n.file-manager-container {\n\twidth: 100%;\n\theight: 100%;\n\tbackground: #fff;\n\theight: 650px;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n/* File manager body */\n.file-manager__body {\n\theight: 100%;\n\twidth: 100%;\n\n\tborder: 1px solid #dee2e6;\n\tborder-top: 0;\n\tborder-bottom-left-radius: 4px;\n\tborder-bottom-right-radius: 4px;\n\n\tdisplay: flex;\n\tflex-direction: row;\n\tbox-sizing: border-box;\n}\n\n/* Files */\n.file-manager__body-files {\n\twidth: 100%;\n}\n\n.file-manager__body-files__toolbar {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\twidth: 100%;\n\tborder-bottom: 1px solid #dee2e6;\n\theight: 34px;\n}\n\n.file-manager__body-files__toolbar .search {\n\tpadding: 0 16px;\n}\n\n.file-manager__body-files__toolbar .input-group-addon {\n\tbackground-color: transparent;\n\tpadding-right: 0;\n}\n\n.file-manager__body .form-control:focus {\n\tbox-shadow: none;\n\tborder-color: #ccc;\n}\n\n/* Outras */\n.file-manager__body-files__table {\n\theight: 575px;\n\toverflow-y: auto;\n}\n\n.file-manager__body-files__table .table {\n\twidth: 100%;\n}\n\n.file-manager__body-files__table .table th {\n\theight: 32px;\n}\n\n.file-manager__body-files__table .table td {\n\theight: 34px;\n}\n\n.file-browser {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tflex-direction: row;\n\tgap: 8px;\n\tpadding: 8px;\n}\n\n.file-browser.list-view {\n\tpadding: 0px;\n}\n\n.file-browser.list-view li a.disabled {\n\tcolor: #aaa;\n\tpadding: 6px 20px;\n}\n\n.popup-overlay {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground: rgba(0, 0, 0, 0.5);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tz-index: 1000;\n}\n\n.popup-content {\n\tbackground: white;\n\tpadding: 20px;\n\tborder-radius: 5px;\n\tposition: relative;\n}\n\n.close-button {\n\tposition: absolute;\n\ttop: 10px;\n\tright: 10px;\n\tbackground: red;\n\tcolor: white;\n\tborder: none;\n\tborder-radius: 5px;\n\tpadding: 5px 10px;\n\tcursor: pointer;\n}\n\n.file-image {\n\tmax-width: 100%;\n\tmax-height: 80vh;\n}\n\n.selection-rect {\n\tpointer-events: none;\n\tz-index: 1000;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
